var render = function render(){var _vm=this,_c=_vm._self._c;return _c('avs-switch',{attrs:{"mdi2":"mdi-white-balance-sunny","mdi1":"mdi-moon-waning-crescent","spantext":_vm.$t('messages.information.switch_theme'),"value":!_vm.isThemeDark},on:{"switch":v => _vm.switchIsThemeDark(!v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }